import { NavLink } from "react-router-dom"
import styles from "./PageNav.module.css"
import Logo from "./Logo"
import { useState } from "react";
import { motion } from 'framer-motion';

function PageNav() {
        const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className={styles.nav}>
        <Logo />
        <div className={styles.hamburger} onClick={() => setIsOpen(!isOpen)}>
            <motion.div
            className={styles.line}
            animate={isOpen ? { rotate: 45, y: 7 } : { rotate: 0, y: 0 }}
            transition={{ duration: 0.3 }}
            />
            <motion.div
            className={styles.line}
            animate={isOpen ? { opacity: 0 } : { opacity: 1 }}
            transition={{ duration: 0.3 }}
            />
            <motion.div
            className={styles.line}
            animate={isOpen ? { rotate: -45, y: -7 } : { rotate: 0, y: 0 }}
            transition={{ duration: 0.3 }}
            />
        </div>
         <ul className={isOpen ? `${styles.second_nav} ${styles.show_nav} ` : `${styles.second_nav}`}>
            <li onClick={() => setIsOpen(!isOpen)} >
                <NavLink  className="link-color" to="/">Home</NavLink>
            </li>
            <li onClick={() => setIsOpen(!isOpen)} >
                <NavLink className="link-color"  to="/pricing">Pricing</NavLink>
            </li>
            <li onClick={() => setIsOpen(!isOpen)} >
                <NavLink  className="link-color" to="/product">Product</NavLink>
            </li>
            <li onClick={() => setIsOpen(!isOpen)} >
                <NavLink  to="/login" className={styles.ctaLink}>Login</NavLink>
            </li>
        </ul>
    </nav>
  )
}

export default PageNav